module.exports = __webpack_public_path__ + "img/icon_microphone.89e34174.png";